import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    msg:"zsc",
    count:0
  },
  mutations: {
    add(state){
      state.count += 1
    },
  },
  actions: {

  }
})
